import { Injectable, computed, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private readonly noScrollClass = "noScroll";
  private loader = signal({
    isLoader: false,
    text: "",
  });

  isLoader = computed(() => this.loader().isLoader);
  loaderText = computed(() => this.loader().text);

  show(loaderText: string = "") {
    document.body.classList.add(this.noScrollClass);

    this.loader.set({
      isLoader: true,
      text: loaderText,
    });
  }

  hide() {
    document.body.classList.remove(this.noScrollClass);
    this.loader.set({
      isLoader: false,
      text: "",
    });
  }
}
